import React from 'react';
import { NotAuthenticatedFilterView } from './NotAuthenticatedFilterView';
import FilterSection from './FilterSection';
import { useRootSelector } from 'common/features/featuresReducer';
import { RootState } from 'rootStore';
import { UserAuthState } from 'common/features/store/duck/account/duck';
import { EarnTypeConstructorFilter } from 'common/api/constructor/util';

interface AllBrandsFilterSectionProps {
    visible: boolean;
    earnType?: EarnTypeConstructorFilter;
}

export const AllBrandsFilterSection = ({ visible, earnType }: AllBrandsFilterSectionProps) => {
    const isAuthenticated = useRootSelector(
        (state: RootState) => state.store.account.userAuthState === UserAuthState.AUTHENTICATED
    );
    return (
        <div>
            {isAuthenticated ? (
                <FilterSection showAZFilter visible={visible} earnType={earnType} />
            ) : (
                <NotAuthenticatedFilterView visible={visible} />
            )}
        </div>
    );
};
